import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useInit} from '../hooks/useInit';
import i18next from 'i18next';
// importar tus componentes necesarios
import SplashScreen from '../screens/splash';
import LoginScreen from '../screens/signin/login';
import HomeScreen from '../screens/menu';
import MenuListScreen from '../screens/menu/list';
import MenuDetailScreen from '../screens/menu/detail';
import HappyScreen from '../screens/menu/happyhour';
import DrinkScreen from '../screens/menu/drink';
import SubDrinkScreen from '../screens/menu/subdrink';
import SpecialScreen from '../screens/menu/special';
import BurritoScreen from '../screens/menu/burrito';
import TacosScreen from '../screens/menu/tacos';
import QuesadillaScreen from '../screens/menu/quesadilla';
import SandwichScreen from '../screens/menu/sandwich';
// import Footer from '@app/components/footer';

const RootNavigator = () => {
  useInit();
  i18next.changeLanguage('es')
  const {
    isFirstLoad, 
    isSingin,
  } = useSelector((state) => state.initLoad);

  return (
    <Router>
      <Routes>
        {isFirstLoad ? (
           <Route path="/*" element={<SplashScreen />} />
        ) : (
          <>
            {isSingin ? (
              <>
                <Route path="/:hash" element={<HomeScreen />} />
                <Route path="MenuList/:hash/:categorie_id" element={<MenuListScreen />} />
                  <Route path="MenuDetail/:hash" element={<MenuDetailScreen />} />
                  <Route path="happyhour" element={<HappyScreen />} />
                  <Route path="drinks" element={<DrinkScreen />} />
                  <Route path="subdrinks" element={<SubDrinkScreen />} />
                  <Route path="special" element={<SpecialScreen />} />
                  <Route path="burrito" element={<BurritoScreen />} />
                  <Route path="tacos" element={<TacosScreen />} />
                  <Route path="quesadillas" element={<QuesadillaScreen />} />
                  <Route path="sandwich" element={<SandwichScreen />} />
                  
              </>
            ) : (
              <Route path="/*" element={<LoginScreen />} />
            )}
          </>
        )}
      </Routes>
      {/* <Footer /> */}
    </Router>
  );
};

export default RootNavigator;
